// Contact details shown in the header, footer, home page and contact page.

export const PHONE = "98453 74254";
export const PHONE_LINK = "tel:+919845374254";

export const offices = [
  {
    title: "Head Office",
    company: "Delmen Mosquito Screens",
    person: "Mr. L. K. Chandrasekar (Proprietor)",
    phone: "98453 74254",
    phoneLink: "tel:+919845374254",
    address: [
      "No. 6, First Cross, Raghavendra Layout,",
      "Silver Spring Road, Munekolala, Marathahalli,",
      "Opp. to Saroj Residency, Bengaluru, Karnataka 560037",
    ],
  },
  {
    title: "Branch Office",
    company: "Delmen Mosquito Screens",
    person: "Nanjappa",
    phone: "80951 16488",
    phoneLink: "tel:+918095116488",
    address: [
      "31, 1st Block, 2nd Main, Bhavani Layout,",
      "Banashankari 3rd Stage, Bangalore 560085",
    ],
  },
  {
    title: "Authorized Dealer",
    company: "AVM Life Style",
    person: "Kandaswamy",
    phone: "80560 35572",
    phoneLink: "tel:+918056035572",
    address: [
      "AVM Life Style Porur, 147A Roja Street,",
      "Sathya Narayana Puram, Mowlivakkam, Porur",
    ],
  },
];

export const SERVICE_AREA =
  "We are accepting local inquiries mostly from Tamil Nadu & Karnataka.";
